var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 377.872,
    height: 302.498,
    viewBox: "0 0 377.872 302.498",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-project-diagram",
    "data-name": "Icon awesome-project-diagram",
    d: "M226.124,188.436H150.749a18.846,18.846,0,0,0-18.844,18.844v75.374A18.846,18.846,0,0,0,150.749,301.5h75.375a18.846,18.846,0,0,0,18.844-18.844V207.28A18.846,18.846,0,0,0,226.124,188.436ZM113.062,18.844A18.846,18.846,0,0,0,94.218,0H18.844A18.846,18.846,0,0,0,0,18.844V94.218a18.846,18.846,0,0,0,18.844,18.844H75.21l43.081,75.4a37.562,37.562,0,0,1,32.458-18.867h.165l-37.852-66.241V75.375H244.967V37.687H113.062ZM358.029,0H282.654a18.846,18.846,0,0,0-18.844,18.844V94.218a18.846,18.846,0,0,0,18.844,18.844h75.374a18.846,18.846,0,0,0,18.844-18.844V18.844A18.846,18.846,0,0,0,358.029,0Z",
    transform: "translate(0.5 0.5)",
    fill: "#291818",
    stroke: "#000",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.07e9fe305644f84976def457650c7a5b.svg";
export { ForwardRef as ReactComponent };